<template>
  <card title="Filters" has-icon additional-classes="slds-card_boundary">
    <template #icon>
      <span class="slds-icon_container slds-icon-standard-filter">
        <svg class="slds-icon slds-icon-action-filter" aria-hidden="true">
          <use xlink:href="../../assets/symbols.svg#filterList" />
        </svg>
      </span>
    </template>
    <p>Ciaoooo</p>
  </card>
</template>
<script>
import Card from '../../components/slds/Card'
export default {
  components: {
    Card
  }
}
</script>
